<template>
  <div
    ref="table"
    class="c-table"
    :class="{
      // 'c-table_scrolled': isScrolled,
      'c-table_scroll_end': isScrollEnd,
      'c-table_scroll': isScroll,
    }"
  >
    <m-column-filters
      ref="columnFilters"
      :column="filteredColumn"
      :reference-list="referenceList"
      :active-filters="activeFilteredColumns"
      @getReferenceValues="getReferenceValues"
      @close="filteredColumn = null"
      @setFilter="setColumnFilter"
      @removeFilter="removeColumnFilter"
    />

    <div
      v-if="data.records.length !== 0"
      :class="{
        'c-table__shadow': data.actions,
        'c-table__shadow_active': data.actions,
        // 'c-table__empty__shadow': data.records.length === 0
      }"
    ></div>
    <div v-if="isScroll" class="c-table__scrollbar-wrapper"></div>

    <perfect-scrollbar ref="wrapper" class="c-table__wrapper" @scroll="scroll">
      <table id="tableWithFixedFirstColumn" ref="container" class="c-table__container">
        <thead ref="header" class="c-table__header">
          <tr v-for="i in levels" :key="i" class="c-table__header-row">
            <th
              v-for="column in getTableColumns(i)"
              :id="`c-table-column-${column.id}`"
              :key="column.id"
              class="c-table__column"
              :colspan="getColspan(column)"
              :rowspan="getRowspan(column)"
              :class="{
                'c-table__column_with_filter': column.type,
                'c-table__column_hidden': isDisabled(column.id),
                'c-table__column_sorted': isSorted(column),
                'c-table__column_highlight': highlightColumns.includes(column.id),
                'c-table__column_release_from_load': column.id === 'release_from_load',
              }"
              @click="highlightColumnOnClick(column.id)"
            >
              <div class="c-table__column-wrapper">
                <div
                  class="c-table__column-label"
                  :class="{
                    'c-table__column-label-children': !isCategory(column) && sortedColumn,
                  }"
                  @click="setSortedColumn(column, sortedColumn)"
                >
                  {{ column.label }}
                </div>

                <div
                  v-if="(column.description || column.type) && data.type !== 'new-calculation-lateness'"
                  class="c-table__column-actions"
                >
                  <div v-if="column.fullName" class="c-table__column-action c-table__column-action_description">
                    <c-button :id="`table-column-button-description-${column.id}`" size="small" icon="info" no-border/>

                    <b-popover
                      placement="top"
                      triggers="hover"
                      :target="`table-column-button-description-${column.id}`"
                    >
                      {{ column.fullName }}
                    </b-popover>
                  </div>

                  <div v-if="isColumnFiltered(column.id)" class="c-table__column-action">
                    <c-button
                      :id="`table-column-button-filter-${column.id}`"
                      size="small"
                      no-border
                      :active="isColumnActiveFiltered(column.id)"
                      :icon="{
                        icon: 'filter-column',
                        activeColor: 'blue',
                      }"
                      @click="openColumnFilterModal(column)"
                    />

                    <b-popover placement="top" triggers="hover" :target="`table-column-button-filter-${column.id}`">
                      {{ isColumnActiveFiltered(column.id) ? 'Изменить фильтр' : 'Применить фильтр' }}
                    </b-popover>
                  </div>
                </div>
              </div>
            </th>

            <th v-if="data.actions && i === 1" class="c-table__column c-table__column_actions" :rowspan="levels">
              <div class="c-table__column-empty"></div>
            </th>
          </tr>
        </thead>

        <tbody class="c-table__records">
          <template v-for="(group, recordIndex) in data.records">
            <tr v-if="group.groupName !== 'total'" :key="`table-record-${recordIndex}`">
              <td
                class="c-table__cell c-table__cell__grey c-table__cell__group__name c-table__cell__double__top__border"
              >
                <div class="c-table__cell-value c-table__cell-value-groupname">
                  <c-button
                    v-b-popover.html="{
                      container: '#app',
                      trigger: 'hover blur',
                      content: 'Добавить сотрудников',
                      placement: 'bottom',
                    }"
                    class="c-table__cell__button__add__post"
                    size="iconic"
                    icon="plus"
                    :disabled="!canEdit"
                    @click="canEdit && $emit('showModalAddWorkers', group)"
                  />
                  {{ group.groupName }}

                  <c-button-2
                    v-if="!isFilialAdmin && (isPostAdmin(group.code) || isPostCook(group.code))"
                    class="c-table__groupname-action"
                    size="iconic"
                    :icon="{ icon: 'money' }"
                    :disabled="!canEdit"
                    @click="canEdit && $emit('showPositionIntervalsModal', group.code)"
                  />
                </div>
              </td>
              <td class="c-table__cell c-table__cell__grey c-table__cell__double__top__border" colspan="30"></td>
            </tr>
            <tr
              v-for="(record, recordIndex) in group.records"
              v-show="record.isShowRow"
              :key="`${group.code || group.groupName}-${record.codeGroup || ''}-${record.id}`"
              class="c-table__record"
              :class="{
                'c-table__record__highlight': highlightRecords.includes(recordIndex + group.groupName),
              }"
            >
              <td
                v-if="data.type === 'new-calculation-lateness'"
                class="c-table__cell_total c-table__cell c-table__cell_number"
                :class="{
                  'c-table__cell__grey': isGreyCell(data.type, 'total', record.isTotalRow),
                }"
              >
                <div class="c-table__cell-value">
                  {{ record['total'].value }}
                </div>
              </td>

              <td
                v-for="column in getTableColumns(levels)"
                :key="column.id"
                class="c-table__cell"
                :class="{
                  'c-table__cell__yellow': isYellowCell(
                    data.type,
                    column.id,
                    record[column.id] ? record[column.id].value : null,
                    record.isTotalRow,
                  ),
                  'c-table__cell__red': column.id === 'depreciation' &&  record[column.id] && record[column.id].value > 0,
                  'c-table__cell__green': column.id === 'premium_for_exceeding_standard' &&  record[column.id] && record[column.id].value > 0,
                  'c-table__cell__grey': group.groupName === 'total',
                  'c-table__cell__blue':
                    column.id === 'total_accrued' || column.id === 'to_payoff' || column.id === 'already_paid',
                  'c-table__cell__hide__borders': group.groupName === 'total' &&  (!record[column.id] || record[column.id].value === null),
                  'c-table__cell__double__top__border': group.groupName === 'total',
                  'c-table__cell_string': column.type === 'string',
                  'c-table__cell_reference': column.type === 'reference',
                  'c-table__cell_number': column.type === 'number',
                  'c-table__cell_date': column.type === 'date',
                  'c-table__cell_hidden': isDisabled(column.id),
                  'c-table__cell_highlight': highlightColumns.includes(column.id),
                  ['c-table__cell_' + column.id]: column.id,
                }"
                @click="highlightRowOnClick(recordIndex + group.groupName, column.id)"
              >
                <c-table-cell-employee
                  v-if="column.id === 'employee' && group.groupName !== 'total'"
                  :record="record"
                  :can-edit="canEdit"
                  @productionRemoveWorkerFromCalc="productionRemoveWorkerFromCalc"
                />
                <c-table-cell-release-from-load
                  v-else-if="column.id === 'release_from_load' && group.groupName !== 'total'"
                  :record="record"
                  :can-edit="canEdit"
                />
                <c-table-cell-intervals
                  v-else-if="column.id === 'working_interval' && group.groupName !== 'total'"
                  :record="record"
                />
                <c-table-cell-prize
                  v-else-if="column.id === 'prize' && group.groupName !== 'total'"
                  :calculation-data="calculationData"
                  :record="record"
                  :calculate-type="calculateType"
                  :can-edit="canEdit"
                  @updateBonuses="updateBonuses"
                />
                <c-table-cell-personal-account-transactions
                  v-else-if="column.id === 'personal_account_transactions' && group.groupName !== 'total'"
                  :calculation-data="calculationData"
                  :calculation-type="calculateType"
                  :record="record"
                  :personal-reasons="personalReasons"
                  :can-edit="canEdit"
                  @updateKPItable="updateKPItable"
                  @updatePersonal="updatePersonal"
                />
                <c-table-cell-fine
                  v-else-if="column.id === 'fine' && group.groupName !== 'total'"
                  :calculation-data="calculationData"
                  :record="record"
                  :calculate-type="calculateType"
                  :can-edit="canEdit"
                  @updateFines="updateFines"
                />
                <c-table-cell-rank
                  v-else-if="column.id === 'rank' && group.groupName !== 'total'"
                  :calculation-data="calculationData"
                  :record="record"
                  :calculate-type="calculateType"
                  :is-edit="true"
                  :can-edit="canEdit"
                  @updateRank="updateRank"
                />
                <c-table-cell-compensation
                  v-else-if="column.id === 'compensation' && group.groupName !== 'total'"
                  :calculation-data="calculationData"
                  :record="record"
                  :can-edit="canEdit"
                  @updateCompensation="updateCompensation"
                />
                <c-table-cell-premium-personal-account
                  v-else-if="
                    column.id === 'premium_personal_account' &&
                      group.groupName !== 'total' &&
                      calculateType === 'byPeriod'
                  "
                  :calculation-data="calculationData"
                  :record="record"
                  :can-edit="canEdit"
                />
                <div
                  v-else-if="
                    column.id === 'salary' ||
                      column.id === 'main_part_salary' ||
                      column.id === 'revenue_standard_hour' ||
                      column.id === 'revenue_standard' ||
                      column.id === 'total_accrued' ||
                      column.id === 'to_payoff' ||
                      column.id === 'already_paid' ||
                      column.id === 'personal_account_accrued' ||
                      column.id === 'personal_account_removed' ||
                      column.id === 'personal_account_balance'
                  "
                  class="c-table__cell-value"
                >
                  {{ numberWithSpaces(column.id, record[column.id] ? record[column.id].value : null) }}
                </div>

                <div v-else-if="column.id === 'premium_personal_account'" class="c-table__cell-value">
                  {{ record.personal_account_transactions.value }}
                </div>

                <div
                  v-else-if="column.id === 'premium_for_exceeding_standard'"
                  class="c-table__cell-value c-table__cell_custom"
                  :class="{
                    'c-table__cell__green': !!getBonusValue(record),
                    'c-table__cell__grey': group.groupName === 'total'
                  }">
                  <cell-loader
                    v-if="premiumPersonalAccountLoading || loadingItem.includes(record.id)"
                    class="new-calculation-loader"
                    :active="premiumPersonalAccountLoading || loadingItem.includes(record.id)"
                  />
                  <span v-else>{{ getBonusValue(record) }}</span>
                </div>

                <div
                  v-else
                  class="c-table__cell-value"
                  :style="{
                    'text-align':
                      data.type === 'new-calculation-lateness' &&
                      column.id !== 'load_sushiChef' &&
                      column.id !== 'load_hotShop'
                        ? 'center'
                        : 'right',
                  }"
                  :class="{
                    'c-table__cell-value__grey':
                      data.type === 'new-calculation-lateness' && isTotalValuesLateness(column.id),
                    'c-table__cell-value__left__border':
                      group.groupName === 'total' &&
                      record[column.id] && record[column.id].value !== null &&
                      column.id !== 'deprivation_coefficient' &&
                      column.id !== 'revenue_standard' &&
                      column.id !== 'corrected_time' &&
                      column.id !== 'bonus_rate' &&
                      column.id !== 'premium_for_exceeding_standard',
                  }"
                >
                  <template v-if="column.id === 'amount_working_time'">
                    <span
                      v-if="record.confidence_level && record.confidence_level !== 'high'"
                      :id="`confidence-tooltip-${recordIndex}-${group.groupName}`"
                      :class="{
                        'c-table__cell-value__low-confidence': record.confidence_level === 'low',
                        'c-table__cell-value__medium-confidence': record.confidence_level === 'medium',
                      }"
                    >
                      {{
                        (!record[column.id] || record[column.id].value == 0 || record[column.id].value === '00:00')
                          ? ''
                          : (record[column.id] ? record[column.id].value : null)
                      }}
                      <span v-if="record.confidence_level === 'low'" class="c-table__cell-value__emoji">⚠️</span>
                      <span v-else-if="record.confidence_level === 'medium'" class="c-table__cell-value__emoji">ℹ️</span>
                    </span>
                    <span v-else>
                      {{
                        (!record[column.id] || record[column.id].value == 0 || record[column.id].value === '00:00')
                          ? ''
                          : (record[column.id] ? record[column.id].value : null)
                      }}
                    </span>
                    <b-popover
                      v-if="record.confidence_level && record.confidence_level !== 'high' && record.correction_type && record.correction_type !== 'none'"
                      :target="`confidence-tooltip-${recordIndex}-${group.groupName}`"
                      triggers="hover"
                      placement="top"
                    >
                      {{ getCorrectionTypeMessage(record.correction_type) }}
                    </b-popover>
                  </template>
                  <template v-else>
                    {{
                      (column.id === 'count_smenas' ||
                        column.id === 'period_compensation' ||
                        column.id === 'corrected_time' ||
                        column.id === 'period_rank' ||
                        column.id === 'premium_for_exceeding_standard' ||
                        column.id === 'depreciation' ||
                        column.id === 'compensation') &&
                        (!record[column.id] || record[column.id].value == 0 || record[column.id].value === '00:00')
                        ? ''
                        : (record[column.id] ? record[column.id].value : null)
                    }}
                  </template>
                </div>
              </td>

              <td v-if="data.actions" class="c-table__cell c-table__cell_actions">
                <div class="c-table__cell-actions">
                  <c-table-actions
                    v-if="data.type === 'employees'"
                    :type="data.type"
                    :record="record"
                    :record-index="recordIndex"
                    :record-count="data.records.length"
                  />
                </div>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </perfect-scrollbar>

    <div v-if="data.records.length === 0" class="c-table__empty__records">
      {{ emptyRecordsLabel }}
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';

import {
  isAdmin,
  isCook,
} from '@/entities/models/calculations';

import Button from '@/components/controls/button';
import Button2 from '@/components/controls2/Button';
import DataTableActions from '@/components/data-table/actions';
import ColumnFiltersModal from '@/components/modals/column-filters';
import DataTableReleaseFromLoadCell from '@/pages/calculations/create/additions/production-cell-release-from-load';
import DataTableEmployeeCell from '@/pages/calculations/create/additions/production-cell-employee';
import DataTableRankCell from '@/pages/calculations/create/additions/production-cell-rank';
import DataTableIntervalsCell from '@/pages/calculations/create/additions/production-cell-intervals';
import DataTablePrizeCell from '@/pages/calculations/create/additions/production-cell-prize';
import DataTablePersonalAccountTransactions
  from '@/pages/calculations/create/additions/production-personal-account-transactions-cell';
import DataTableFineCell from '@/pages/calculations/create/additions/production-cell-fine';
import DataTableCompensationCell from '@/pages/calculations/create/additions/production-cell-compensation';
import DataTablePremiumPersonalAccountCell
  from '@/pages/calculations/create/additions/production-cell-premium-personal-account';
import Loader from '@/components/cell-loader.vue';

export default {
  name: 'data-table-create-calculations-production',

  components: {
    'cell-loader': Loader,
    'c-button': Button,
    'c-button-2': Button2,
    'c-table-actions': DataTableActions,
    'c-table-cell-release-from-load': DataTableReleaseFromLoadCell,
    'c-table-cell-employee': DataTableEmployeeCell,
    'c-table-cell-rank': DataTableRankCell,
    'c-table-cell-intervals': DataTableIntervalsCell,
    'c-table-cell-prize': DataTablePrizeCell,
    'c-table-cell-personal-account-transactions': DataTablePersonalAccountTransactions,
    'c-table-cell-fine': DataTableFineCell,
    'c-table-cell-compensation': DataTableCompensationCell,
    'c-table-cell-premium-personal-account': DataTablePremiumPersonalAccountCell,
    'm-column-filters': ColumnFiltersModal,
  },

  props: [
    'levels',
    'maxWidth',
    'isFilialAdmin',
    'data',
    'calculationData',
    'enabledFields',
    'disabledColumns',
    'sortedColumn',
    'filteredColumns',
    'activeFilteredColumns',
    'referenceList',
    'emptyRecordsLabel',
    'calculateType',
    'personalReasons',
    'userColumns',
    'premiumPersonalAccountLoading',
    'loadingItem',
    'bonusesForExceeded',
    'canEdit',
  ],

  data() {
    return {
      timeoutId: null,
      isScrolled: false,
      isScrollEnd: false,
      isScroll: false,
      positionTop: 0,
      filterFieldsBlockHeight: 0,
      filteredColumn: null,
      highlightRecords: [],
      highlightColumns: [],
      bonusesForExceededLocal: [],
    };
  },

  computed: {
    ...mapGetters('app', ['sidebarCollapsed']),

  },

  watch: {
    "calculationData.calc": {
      deep: true,
      handler(value) {
      },
    },

    "data.records" : function() {
      setTimeout((a) =>
        this.updatePositionTop(), 1500);
    },

    'enabledFields': function() {
      this.updatePositionTop();
    },

    'isScrollEnd': function() {
      // console.log('value: ', value)
    },

    'data.columns': function() {
      //  console.log('value: ', value)
    },

    'disabledColumns': function(value) {
      const enabledColumns = this.data.columns.filter((item) => !value.includes(item.id));

      const max = Math.max.apply(
        null,
        enabledColumns.map((item) => item.level),
      );

      this.$emit('setLevelsTableData', max + 1);
      this.$emit('disabledcolumns', {c: this.value, t: 'production'});
      // this.levels = max + 1;

      this.setTableShadow();
    },

    'loadingItem': function(v) {
    },

    'bonusesForExceeded': function(v) {
      this.bonusesForExceededLocal = v;
    },
  },

  beforeUnmount() {
    window.removeEventListener('touchend', this.handleTouchMove);
    if (document.querySelector('.layout') !== null)
      document.querySelector('.layout').removeEventListener('scroll', this.handleLayoutScroll);
    if (document.querySelector('.ps') !== null) {
      document.querySelector('.ps').removeEventListener('scroll', this.handleTableScroll);
    }
  },

  async created() {
    if (this.userColumns && this.calculateType === 'byPeriod')
      this.data.columns = this.data.columns.filter((item) => this.userColumns.includes(item.id));

  },

  mounted() {
    if (this.userColumns && this.calculateType === 'byPeriod')
      this.data.columns = this.data.columns.filter((item) => this.userColumns.includes(item.id));
    this.updatePositionTop();

    window.addEventListener('touchend', this.handleTouchMove, {
      passive: false,
    });
    if (document.querySelector('.layout') !== null)
      document.querySelector('.layout').addEventListener('scroll', this.handleLayoutScroll);
    if (document.querySelector('.ps') !== null) {
      document.querySelector('.ps').addEventListener('scroll', this.handleTableScroll);
    }

    this.isScroll = this.$refs.wrapper.$el.clientWidth < this.$refs.wrapper.$el.scrollWidth;

    setTimeout(() => {
      this.updatePositionTop();
      this.setTableShadow();
    }, 1500);
  },

  methods: {
    isPostAdmin(code) {
      return isAdmin(code);
    },

    isPostCook(code) {
      return isCook(code);
    },

    updateFines(params) {
      this.$emit('updateFines', params);
    },

    updateRank(params) {
      this.$emit('updateRank', params);
    },

    updateCompensation(params) {
      this.$emit('updateCompensation', params);
    },
    updateBonuses(params) {
      this.$emit('updateBonuses', params);
    },

    updatePersonal(params) {
      this.$emit('updatePersonal', params);
    },

    updateKPItable() {
      if (this.calculateType === 'byPeriod') {
        this.$emit('updateKPItable');
      }
    },

    productionRemoveWorkerFromCalc(record) {
      // console.log("!!!", record);
      this.$emit('productionRemoveWorkerFromCalc', record);
    },

    highlightColumnOnClick(columnId) {
      if (!this.highlightColumns.includes(columnId)) {
        this.highlightColumns.push(columnId);
      } else {
        const index = this.highlightColumns.indexOf(columnId);
        if (index !== -1) {
          this.highlightColumns.splice(index, 1);
        }
      }
    },
    highlightRowOnClick(rowName, columnId) {
      if (
        columnId !== 'rank' &&
        columnId !== 'release_from_load' &&
        columnId !== 'working_interval' &&
        columnId !== 'prize' &&
        columnId !== 'personal_account_transactions' &&
        columnId !== 'fine' &&
        columnId !== 'compensation' &&
        columnId !== 'employee' &&
        columnId !== 'premium_personal_account' &&
        this.calculateType === 'byPeriod'
      ) {
        if (!this.highlightRecords.includes(rowName)) {
          this.highlightRecords.push(rowName);
        } else {
          const index = this.highlightRecords.indexOf(rowName);
          if (index !== -1) {
            this.highlightRecords.splice(index, 1);
          }
        }
      }
    },

    isTotalValuesLateness(colId) {
      const columnGroupName = colId.split('_').pop();
      return columnGroupName === 'inTotal';
    },

    isYellowCell(tableType, columnId, value, isTotalRow) {
      if (tableType === 'new-calculation-lateness' && !isTotalRow) {
        const columnName = columnId.split('_').slice(0, -1).join('_');
        if (columnName === 'load' && value <= 300) {
          return true;
        }
        if (columnName === 'less_five' && value > 5 && value < 10) {
          return true;
        }
        if (columnName === 'five_to_ten' && value < 2 && value) {
          return true;
        }
      }
      return false;
    },

    isGreyCell(tableType, columnId, isTotalRow) {
      if (isTotalRow && tableType === 'new-calculation-lateness') {
        const columnGroupName = columnId.split('_').pop();
        const columnName = columnId.split('_').slice(0, -1).join('_');
        if (
          columnGroupName !== 'inTotal' &&
          columnName !== 'less_five' &&
          columnName !== 'five_to_ten' &&
          columnName !== 'more_ten'
        ) {
          return true;
        }

        if (columnId === 'total') {
          return true;
        }
      }

      return false;
    },

    numberWithSpaces(columnId, x) {
      if (columnId !== 'total_accrued' && columnId !== 'already_paid' && columnId !== 'to_payoff') {
        if (x === 0) {
          return '';
        }
      }
      if (x === null) {
        return null;
      }
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    },

    handleTableScroll() {
      this.setTableShadow();
    },

    handleTouchMove() {
      // if (!e.cancelable) {
      //   e.preventDefault();
      //   return true
      // }
    },

    setTableShadow() {
      // alert("shadow!")
      if (this.data.actions === undefined) {
        return;
      }
      const ps = document.querySelector('.ps');
      // const tableWrapper = document.querySelector(".c-table__wrapper");
      const tableWrapperShadow = document.querySelector('.c-table__shadow');

      if (!ps || !tableWrapperShadow) return;

      const fullScrollWidth = ps.scrollWidth - ps.clientWidth;

      const diff = Math.abs(ps.scrollLeft - fullScrollWidth);

      if (diff > 3 && this.data.records.length !== 0) {
        tableWrapperShadow.classList.add('c-table__shadow_active');
      } else {
        tableWrapperShadow.classList.remove('c-table__shadow_active');
      }
    },

    resetColumnFilters() {
      this.activeFilteredColumns = [];

      this.$refs.columnFilters.resetFilters();
    },

    isColumnFiltered(columnId) {
      if (this.filteredColumns === undefined) {
        return false;
      }
      const result = this.filteredColumns.findIndex((i) => i === columnId);

      return result !== -1;
    },

    isColumnActiveFiltered(columnId) {
      const c = this.activeFilteredColumns.findIndex((i) => i.id === columnId);

      return c !== -1;
    },

    setColumnFilter(e) {
      const c = this.activeFilteredColumns.findIndex((i) => i.id === e.id);

      const filterOptions = {
        id: e.id,
        type: e.type,
        searchType: e.filter.condition.value,
        value: e.type === 'number' && e.filter.condition.value === '4' ? e.filter.rangeValue : e.filter.value,
      };

      if (
        c === -1 &&
        (filterOptions.type === 'string' || filterOptions.type === 'number') &&
        filterOptions.value === ''
      ) {
        return;
      }

      if (
        c !== -1 &&
        (filterOptions.type === 'string' || filterOptions.type === 'number') &&
        filterOptions.value === ''
      ) {
        this.activeFilteredColumns.splice(c, 1);
        return;
      }

      if (
        c === -1 &&
        filterOptions.type === 'number' &&
        filterOptions.searchType === '4' &&
        (filterOptions.value.end === '' || filterOptions.value.start === '')
      ) {
        return;
      }

      if (
        c !== -1 &&
        filterOptions.type === 'number' &&
        filterOptions.searchType === '4' &&
        (filterOptions.value.end === '' || filterOptions.value.start === '')
      ) {
        this.activeFilteredColumns.splice(c, 1);
        return;
      }

      if (c === -1 && filterOptions.type === 'list' && filterOptions.value.length === 0) {
        return;
      }

      if (c !== -1 && filterOptions.value.length === 0) {
        this.activeFilteredColumns.splice(c, 1);
        return;
      }

      if (c === -1) {
        this.activeFilteredColumns.push(filterOptions);
      } else {
        this.activeFilteredColumns.splice(c, 1);
        this.activeFilteredColumns[c] = filterOptions;
      }
    },

    isCategory(column) {
      return column.isCategory === 1;
    },

    isSorted(column) {
      return column.isSorted;
    },

    setSortedColumn(column, sortedColumn) {
      if (column.isCategory !== 1 && sortedColumn !== undefined) {
        const c = this.data.columns.findIndex((i) => i.id === sortedColumn.sortBy);

        if (c !== -1) {
          this.data.columns[c].isSorted = false;
        }

        column.isSorted = true;
        this.sortedColumn.sortBy = column.id;

        if (column.id === sortedColumn.sortBy) {
          this.sortedColumn.sortType = this.sortedColumn.sortType === 'asc' ? 'desc' : 'asc';
        } else {
          this.sortedColumn.sortType = 'asc';
        }

        this.$emit('sortedEvent', this.sortedColumn);
      }
    },

    removeColumnFilter(columnId) {
      const c = this.activeFilteredColumns.findIndex((i) => i.id === columnId);

      if (c !== -1) {
        this.activeFilteredColumns.splice(c, 1);
      }
    },

    openColumnFilterModal(column) {
      const c = this.filteredColumns.findIndex((i) => i === column.id);

      if (c !== -1) {
        this.filteredColumn = column;
      }
    },

    handleLayoutScroll() {
      const layout = document.querySelector('.layout');
      const app = document.querySelector('.app');

      let result = layout.scrollTop - this.positionTop;

      if (app.offsetWidth < 992) {
        result += 50;
      }

      //  console.log(this.positionTop);
      if (layout.scrollTop > this.positionTop) {
        if (this.$refs.header) {
          this.$refs.header.classList.add('c-table__header-shadow');
          this.$refs.header.style.transform = `translateY(${result}px)`;
        }
      } else if (this.$refs.header) {
        this.$refs.header.classList.remove('c-table__header-shadow');
        this.$refs.header.style.transform = 'none';
      }
    },

    updatePositionTop() {
      const layout = document.querySelector('.layout');
      // const header = this.$refs.header ? this.$refs.header.getBoundingClientRect() : {top: 0};
      const mainTable = this.$refs.table.getBoundingClientRect();
      this.positionTop = mainTable.top + 10 + layout.scrollTop;
      if (this.$store.state.calculations.isFirstLoading) {
        setTimeout(() => {
          const table = document.querySelector('.new-calculation-table');
          if (table) {
            this.positionTop = this.positionTop + table.getBoundingClientRect().height + 8;
            this.$store.commit('calculations/setFirstLoadingToFalse');
          }
        }, 200);
      }
    },

    getChildrens(columnId) {
      return this.data.columns.filter((item) => item.parentColumnId === columnId);
    },

    getTableColumns(level) {
      let out = [];
      const columns = this.data.columns.filter((item) => item.parentColumnId === undefined);
      if (level === 1) {
        out = out.concat(columns);
      } else if (level === 2) {
        Object.keys(columns).forEach((i) => {
          out = out.concat(this.getChildrens(columns[i].id));
        });
      } else if (level === 3) {
        Object.keys(columns).forEach((i) => {
          const childrens = this.getChildrens(columns[i].id);
          Object.keys(childrens).forEach((ii) => {
            out = out.concat(this.getChildrens(childrens[ii].id));
          });
        });
      }

      return out;
    },

    getColumns(level) {
      let cols = [];

      if (level === 1) {
        cols = this.data.columns.filter((col) => col.parentColumnId === undefined);
      } else if (level === 2) {
        const rootCols = this.data.columns.filter((col) => col.parentColumnId === undefined);

        Object.keys(rootCols).forEach((i) => {
          const rootCol = rootCols[i];

          const childrens = this.data.columns.filter((col) => col.parentColumnId === rootCol.id);

          cols = cols.concat(childrens);
        });
      } else if (level === 3) {
        const rootCols = this.data.columns.filter((col) => col.parentColumnId === undefined);

        Object.keys(rootCols).forEach((i) => {
          const rootCol = rootCols[i];

          const childrens = this.data.columns.filter((col) => col.parentColumnId === rootCol.id);

          Object.keys(childrens).forEach((ii) => {
            const childrens2 = this.data.columns.filter((col) => col.parentColumnId === childrens[ii].id);
            cols = cols.concat(childrens2);
          });
        });
      }

      return cols;
    },

    getColspan(column) {
      const children = this.data.columns.filter((col) => col.parentColumnId === column.id);

      let count = children.length;

      if (column.level === 0) {
        Object.keys(children).forEach((c) => {
          const childrenChildren = this.data.columns.filter((col) => col.parentColumnId === children[c].id).
            filter((colChild) => !this.disabledColumns.includes(colChild.id));

          count += childrenChildren.length;
        });
      }

      Object.keys(children).forEach((i) => {
        const result = this.disabledColumns.find((item) => item === children[i].id || children[i].isCategory === 1);

        if (result) {
          count -= 1;
        }
      });

      return count;
    },

    getRowspan(column) {
      const children = this.data.columns.filter((col) => col.parentColumnId === column.id);

      if (this.levels === 3) {
        if (column.level === 0 && children.length === 0) {
          return 3;
        }
        if (column.level === 1 && children.length === 0) {
          return 2;
        }
      } else if (this.levels === 2) {
        if (column.level === 0 && children.length === 0) {
          return 2;
        }
      }

      return 1;
    },

    getSeletItemLabel(record, column) {
      let cell = null;

      if (column.items) {
        const item = column.items.find((i) => i.value === record[column.name]);

        cell = item ? item.label : '-';
      } else {
        cell = '-';
      }

      return cell;
    },

    scroll(e, toLeft) {
      if (toLeft) {
        this.$refs.wrapper.$el.scrollLeft = 0;
      }
      // const layout = document.querySelector('.layout');
      // // layout.classList.add('layout-touch-action-none');
      // this.isScrolled = this.$refs.wrapper.scrollLeft > 0;
      // const containerWidth = this.$refs.container.offsetWidth;
      // const wrapperWidth = this.$refs.wrapper.offsetWidth;
      // const scrollLeft = this.$refs.wrapper.scrollLeft;

      setTimeout(() => {
        this.isScroll = this.$refs.wrapper.$el.clientWidth < this.$refs.wrapper.$el.scrollWidth;
      }, 300);

      this.isScrollEnd =
        this.$refs.wrapper.$el.offsetWidth + this.$refs.wrapper.$el.scrollLeft === this.$refs.wrapper.$el.scrollWidth;
      // c-table__container__shadow-first-column

      // console.log(this.$refs.wrapper.scrollLeft)
      const table = document.getElementById('tableWithFixedFirstColumn');
      if (this.$refs.wrapper.$el.scrollLeft > 0) {
        table.classList.add('c-table__container__shadow-first-column');
      } else {
        table.classList.remove('c-table__container__shadow-first-column');
      }

      // layout.classList.remove('layout-touch-action-none');
    },

    isDisabled(id) {
      return this.disabledColumns.find((item) => item === id);
    },

    getReferenceValues(e) {
      this.$emit('getReferenceValues', e);
    },

    getBonusValue(record) {
      if (this.bonusesForExceededLocal.length > 0) {
        const bonusEntry = this.bonusesForExceededLocal.find(bonus => bonus.worker_id === record.id);

        if (bonusEntry) {
          return bonusEntry.bonus;
        }
      }

      return record.premium_for_exceeding_standard.value;
    },

    getCorrectionTypeMessage(correctionType) {
      const messages = {
        auto_closed: 'Автозакрытие смены',
        inverted_entry: 'Ошибка сотрудника?',
        inverted_exit: 'Ошибка сотрудника?',
        cascade_rejected: 'Ошибка сотрудника?',
        no_exit_found: 'Ошибка сотрудника?',
        none: 'Все хорошо!',
      };

      if (!correctionType) {
        console.warn('getCorrectionTypeMessage: correctionType is falsy', correctionType);
        return 'Неизвестная причина';
      }

      const type = String(correctionType).trim();
      const result = messages[type];
      
      if (!result) {
        console.warn('getCorrectionTypeMessage: unknown correctionType', type, 'Available keys:', Object.keys(messages));
      }
      
      return result || 'Неизвестная причина';
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";

.c-table {
  position: relative;
  display: inline-block;
  max-width: 100%;

  &__groupname-action {
    margin-left: 12px;
  }

  &__scrollbar-wrapper {
    position: fixed;
    height: 24px;
    background: white;
    box-shadow: $box-shadow;
    bottom: 0;
    left: 0;
    z-index: 100;
    transition: 0.2s;

    @media screen and (max-width: 992px) {
      display: none;
    }
  }

  @media screen and (max-width: 992px) {
    max-width: 100%;
  }

  @media screen and (max-width: 700px) {
    margin: 0 -20px;
    width: calc(100% + 40px);
    max-width: none;
  }

  &__wrapper {
    overflow-x: auto;
    overflow-y: hidden;
    position: relative;
    transition: 0.2s;
    display: inline-block;
    width: 100%;

    &::-webkit-scrollbar {
      width: 4px !important;
      height: 4px !important;
      background: white;
      cursor: pointer;
      z-index: 300;
      position: relative;
      border-radius: 10px;
    }

    &::-webkit-scrollbar-thumb {
      background: $color-secondary;
      border-radius: 10px;
      background-clip: padding-box;
      border: none !important;
    }

    &::-webkit-scrollbar-track {
      background: #dfe4ef;
      width: 4px !important;
      border-radius: 10px;
      z-index: 300;
      position: relative;
    }

    @media screen and (max-width: 992px) {
      width: 100%;
    }
  }

  &__records {
    & ::v-deep .c-table__record__highlight + .c-table__record__highlight td:first-child:before {
      border-top-color: #dfe4ef !important;
    }

    & ::v-deep .c-table__record__highlight + .c-table__record__highlight td:after {
      border-top-color: #dfe4ef !important;
    }
  }

  &__record {
    &__highlight {
      background: #fff3f8 !important;

      ::v-deep & .c-table__cell_employee {
        background: #fff3f8 !important;
      }

      ::v-deep & td:first-child:before {
        border-top: 1px solid #ff238d !important;
        border-bottom: 1px solid #ff238d !important;
        border-left: 1px solid #ff238d !important;
      }

      ::v-deep & td:not(:first-of-type):after {
        content: "";
        position: absolute;
        top: -1px;
        bottom: -1px;
        pointer-events: none;
        left: -1px;
        right: -1px;
        border-top: 1px solid #ff238d;
        border-bottom: 1px solid #ff238d;
      }

      ::v-deep & td:last-child:after {
        border-right: 1px solid #ff238d !important;
      }
    }

    &:last-child ::v-deep .c-table__cell_highlight:after {
      border-bottom: 1px solid #ff238d !important;
    }

    &:last-child ::v-deep .c-table__cell__hide__borders.c-table__cell_highlight {
      border-right-style: groove !important;
    }

    & ::v-deep .c-table__cell_highlight + .c-table__cell_highlight:after {
      border-left-color: #dfe4ef;
    }
  }

  &__shadow {
    position: absolute;
    background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, #001550 100%);
    width: 10px;
    height: calc(100% - 10px);
    right: 92px;
    opacity: 0;
    bottom: 10px;
    visibility: hidden;
    z-index: 80;
    transition: 0.2s;
  }

  &__empty__shadow {
    right: 0;
  }

  &__empty__records {
    border: 1px solid $color-border-alt;
    width: 100%;
    height: 200px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    z-index: $z-index-loader;
    background: white;
    color: $label;
    font-size: 15px;
  }

  &__shadow_active {
    opacity: 0.15;
    visibility: visible;
  }

  &_scroll {
    &_shadow_right:after {
      content: "";
      position: absolute;
      right: 0;
      z-index: 100;
      pointer-events: none;
      width: 28px;
      height: 100%;
      top: 0;
      background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, #ffffff 100%);
    }

    .c-table__shadow {
      visibility: visible;
      opacity: 0.15;
    }

    .c-table__column_actions {
      &:after {
        visibility: visible !important;
        opacity: 0.15 !important;
      }
    }

    &.c-table_scroll_end {
      .c-table__shadow {
        visibility: hidden;
        opacity: 0;
      }

      .c-table__column_actions {
        &:after {
          visibility: hidden !important;
          opacity: 0 !important;
        }
      }
    }
  }

  &_scrolled {
    border-left: 1px solid $color-border-light;

    @media screen and (max-width: 992px) {
      border-left: none;

      &:before {
        position: absolute;
        content: "";
        width: 22px;
        height: 100%;
        background: linear-gradient(90deg, #ffffff 0%, rgba(255, 255, 255, 0) 100%);
        top: 0;
        left: 0;
        z-index: 100;
      }
    }
  }

  .c-table {
    &__container {
      border-collapse: collapse;
      width: 99%;
      margin-right: 10px;

      ::v-deep .c-table__header-row:first-child th:first-child,
      ::v-deep td:first-child {
        position: sticky;
        background: white;
        left: 0;
        z-index: 10;
      }

      &__shadow-first-column .c-table__header-row:first-child th:first-child:after,
      &__shadow-first-column ::v-deep td:first-child:after {
        content: "";
        position: absolute;
        top: 0;
        right: -10px;
        width: 10px;
        height: 100%;
        background: linear-gradient(90deg, #001550 0%, rgba(255, 255, 255, 0) 100%);
        opacity: 0.15;
      }

      &__shadow-first-column ::v-deep td.c-table__cell__group__name:after {
        width: 0;
        height: 0;
      }

      ::v-deep .c-table__header-row:first-child th:first-child:before,
      ::v-deep td:first-child:before {
        content: "";
        position: absolute;
        top: -1px;
        bottom: -1px;
        left: -1px;
        right: -1px;
        border-left: 1px solid #dfe4ef;
        pointer-events: none;
      }

      ::v-deep td.c-table__cell__group__name:first-child:before {
        border-right: 1px solid #f5f7fa;
      }
    }

    &__header {
      border-bottom: 2px solid $color-border-light;
      position: relative;
      background: $color-border-light;
      z-index: 70;
    }

    &__header-row {
      & ::v-deep .c-table__column_highlight + .c-table__column_highlight .c-table__column-wrapper:before {
        border-left-color: #dfe4ef !important;
      }
    }

    &__header-shadow:after {
      content: "";
      position: absolute;
      background: linear-gradient(#001550, rgba(255, 255, 255, 0));
      width: 100%;
      height: 10px;
      opacity: 0.15;
      z-index: 69;
      bottom: -10px;
      left: 0;
    }

    &__column {
      text-align: left;
      position: relative;
      border: 1px solid $color-border-light;
      vertical-align: top;
      height: 1px;
      padding: 0;
      transition: 0.2s;

      &_hidden {
        width: 0;
        border: none;
        overflow: hidden;
        display: none;
        // margin-left: -1px;

        .c-table__column-wrapper {
          width: 0;
          padding: 0;
          border: none;
        }
      }

      &_with {
        &_filter {
          .c-table__column {
            &-wrapper {
              flex-direction: column;
            }

            &-actions {
              margin-top: 10px;
            }
          }
        }
      }

      &_sorted {
        .c-table__column-label {
          color: $color-primary;
        }
      }

      &_highlight {
        & ::v-deep .c-table__column-wrapper {
          background: #fff3f8 !important;
        }

        & ::v-deep .c-table__column-wrapper:before {
          content: "";
          position: absolute;
          top: -1px;
          bottom: -1px;
          left: -1px;
          right: -1px;
          border-top: 1px solid #ff238d;
          border-left: 1px solid #ff238d;
          border-right: 1px solid #ff238d;
        }
      }

      &_release_from_load {
        max-width: 85px;
      }

      &-label {
        color: $color-label;
        font: {
          size: 12px;
          weight: 500;
        }
        line-height: 13px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;

        &-children {
          cursor: pointer;
        }
      }

      &-wrapper {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        padding: 10px;
        height: 100%;
        background: white;
      }

      &-actions {
        display: flex;
        justify-content: space-between;
      }

      &-action {
        width: 14px;
        height: 14px;

        .c-button {
          width: 14px;
          height: 14px;
        }

        &_description {
          margin-left: -3px;
        }
      }

      &_actions {
        position: sticky;
        right: 0;
        border-right: none;
        z-index: 30;

        &:after {
          content: "";
          position: absolute;
          background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, #001550 100%);
          width: 10px;
          height: 100%;
          left: -11px;
          opacity: 0;
          bottom: 0;
          visibility: hidden;
          z-index: 40;
        }
      }

      &-empty {
        background: white;
        width: calc(100% + 1px);
        height: calc(100% + 2px);
        border-right: 1px solid $color-border-light;
        border-left: 1px solid $color-border-light;
        border-bottom: 2px solid $color-border-light;
        margin-left: -1px;
        position: relative;
      }
    }

    &__cell {
      position: relative;
      border: 1px solid $color-border-light;
      padding: 0;
      height: 1px;
      transition: 0.2s;

      &__yellow {
        background: rgb(253, 255, 179);
      }

      &__red {
        background: #ffe6f2;
      }

      &__green {
        background: #d0f4e3;
      }

      &__grey {
        background: #f5f7fa !important;
      }

      &__blue {
        background: #e1edff !important;
      }

      &__hide__borders {
        border-right-style: hidden;
      }

      &__double__top__border {
        border-top: 2px solid #dfe4ef;
      }

      &_total_accrued {
        border-right: solid 1px #ffffff !important;
      }

      &_custom{
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-end;
      }

      &_salary,
      &_main_part_salary,
      &_revenue_standard_hour,
      &_revenue_standard,
      &_total_accrued,
      &_already_paid,
      &_personal_account_accrued,
      &_personal_account_removed,
      &_personal_account_balance,
      &_to_payoff {
        &::v-deep .c-table__cell-value {
          text-align: right !important;
          white-space: nowrap !important;
        }
      }

      &_highlight {
        background: #fff3f8 !important;

        &:after {
          content: "";
          position: absolute;
          pointer-events: none;
          top: -1px;
          bottom: -1px;
          z-index: 1;
          left: -1px;
          right: -1px;
          border-left: 1px solid #ff238d;
          border-right: 1px solid #ff238d;
        }
      }

      &_number {
        & .c-table__cell-value {
          text-align: right;
        }
      }

      &__button__add__post {
        & ::v-deep .c-button__wrapper {
          width: 22px !important;
          height: 22px !important;
          margin-right: 10px;
        }

        & ::v-deep svg {
          height: 10px !important;
          width: 10px !important;
          fill: #0066ff;
        }

        & ::v-deep .c-icon_plus {
          margin-left: -5px;
          margin-top: -5px;
        }
      }

      &_rank {
        & .c-table__cell-value {
          text-align: left;
        }
      }

      &_hidden {
        width: 0;
        overflow: hidden;
        border: none;
        display: none;

        .c-table__cell-value,
        .c-table__cell-cell {
          width: 0;
          padding: 0;
        }
      }

      &-cell {
        transition: 0.2s;
      }

      &-value {
        line-height: 13px;
        font-size: 13px;

        &__low-confidence {
          color: #e53935;
        }

        &__medium-confidence {
          color: #263fff;
        }

        padding: 10px;
        transition: 0.2s;

        &__left__border {
          border-left: solid 1px #dfe4ef;
        }

        &__grey {
          color: #8e9cbb;
        }

        &-groupname {
          font-weight: bold;
          display: inline-flex;
          align-items: center;
          white-space: nowrap;
        }
      }

      &-pre-formatted {
        white-space: pre;
      }

      &_actions {
        position: sticky;
        right: 0;
        border-right: none;
        z-index: 20;
      }

      &-actions {
        background: white;
        width: calc(100% + 1px);
        height: 100%;
        display: flex;
        align-items: center;
        border-right: 1px solid $color-border-light;
        border-left: 1px solid $color-border-light;
        margin-left: -1px;
      }
    }
  }

  #c-table-column-count_smenas {
    & .c-table__column-wrapper {
      min-width: 60px;
    }
  }

  #c-table-column-main_part_salary {
    & .c-table__column-wrapper {
      min-width: 78px;
    }
  }

  #c-table-column-revenue_standard_hour {
    & .c-table__column-wrapper {
      min-width: 75px;
    }
  }

  #c-table-column-bonus_rate {
    & .c-table__column-wrapper {
      min-width: 65px;
    }
  }

  #c-table-column-premium_for_exceeding_standard {
    & .c-table__column-wrapper {
      min-width: 100px;
    }
  }

  #c-table-column-total_accrued {
    & .c-table__column-wrapper {
      min-width: 95px;
    }
  }

  #c-table-column-already_paid {
    & .c-table__column-wrapper {
      min-width: 100px;
    }
  }

  #c-table-column-to_payoff {
    & .c-table__column-wrapper {
      min-width: 85px;
    }
  }

  #c-table-column-release_from_load {
    & .c-table__column-wrapper {
      min-width: 90px;
    }
  }
}

::v-deep .ps__rail-x {
  z-index: 351;
  background: #ffffff !important;
}

::v-deep .ps__rail-x:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  transform: translate(-30px, 0);
  box-shadow: 0px 0px 15px rgba(0, 21, 80, 0.3);
  z-index: -1;
  height: 24px;
  width: calc(100vw - 60px);
  background: #ffffff;
}

::v-deep .ps__rail-x:after {
  content: "";
  position: absolute;
  top: 50%;
  left: 0;
  transform: translate(0, calc(-50% + 1px));
  border-radius: 10px;
  z-index: -1;
  height: 4px;
  width: calc(100% - 34px);
  background: #dfe4ef;
}
</style>
